<template>
	<div>
		<div class="app-heading pd:md">
			<div v-t="'faq'" class="app-title"></div>
		</div>

		<section
			v-show="isLoading"
			class="preloader">
		</section>
		<section
			v-show="!isLoading"
			class="pd:md">
			<ol class="info-list">
				<li
					v-for="(faq, index) in faq"
					v-show="!faq.hidden && (!faq.requireLogin || faq.requireLogin && $store.state.auth.uid)"
					:key="index"
					class="entry">
					<div class="question">{{ faq.question }}</div>

					<div v-if="Array.isArray(faq.answer)">
						<div
							v-for="(answer, indexAnswer) in faq.answer"
							:key="indexAnswer"
							class="answer">
							<ol v-if="Array.isArray(answer)">
								<li
									v-for="(answerSub, indexAnswerSub) in answer"
									:key="indexAnswerSub" v-html="answerSub">
								</li>
							</ol>

							<div v-else>{{ answer }}</div>
						</div>
					</div>

					<div
						v-else
						class="answer">
						{{ faq.answer }}
					</div>
				</li>
			</ol>
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'faq',
	inject: ['$util'],
	data () {
		return {
			isLoading: true,
			faq: {},
			telco: {
				subscription_package_description: process.env.VUE_APP_SUBSCRIPTION_PACKAGE_DESCRIPTION,
				sms: {
					unsubscribe: {
						keyword: process.env.VUE_APP_WAP_UNSUBSCRIBE_KEYWORD,
						shortcode: process.env.VUE_APP_WAP_UNSUBSCRIBE_SHORTCODE
					}
				}
			},
			urlWeb: process.env.VUE_APP_URL_WEB
		}
	},
	computed: {
		...mapState('i18n', {
			localeDefault: 'default'
		})
	},
	mounted () {
		this.$util.trimHtml('.info-list')
	},
	activated () {
		this.$util.scrollToTop()
	},
	watch: {
		localeDefault: {
			async handler (localeDefault) {
				this.isLoading = true

				// unfinished, package keyword shortcode must get from api based on telco
				let idbLang = (await this.$db.i18n.where({ locale: localeDefault }).toArray())[0]

				this.faq = idbLang && idbLang.custom ? idbLang.custom.faq : require(`@/assets/translations/${this.$store.state['i18n'].fallback}.json`)['custom_content'].faq

				await this.$store.dispatch('auth/_awaitAuth')
				const conditions = {
					logged_in: !!this.$store.state.auth.uid,
					otp_login: JSON.parse(process.env.VUE_APP_OTP_LOGIN_IS_SUPPORTED || null),
					he: JSON.parse(process.env.VUE_APP_HEADER_ENRICHMENT_IS_SUPPORTED || null),
					wap_unsubscribe: JSON.parse(process.env.VUE_APP_WAP_UNSUBSCRIBE_IS_SUPPORTED || null),
					wifi_flow: JSON.parse(process.env.VUE_APP_FLOW_WIFI_IS_SUPPORTED || null),
					wifi_flow_n: !JSON.parse(process.env.VUE_APP_FLOW_WIFI_IS_SUPPORTED || null),
					msisdn_original: JSON.parse(process.env.VUE_APP_MSISDN_IS_ORIGINAL || null),
					reset_password_explicit: !JSON.parse(process.env.VUE_APP_RESET_PASSWORD_IS_EXPLICITLY_DISABLED || null)
				}

				this.faq = this.faq
					.filter(content => !content.hidden) // filter hidden content
					.map(content => { // select answer
						let answer = content.answers
							.sort((a, b) => -(a.requirements ? b.requirements.length - a.requirements.length : content.answers.length)) // sort answers
							.reduce((answerCandidate, answer) => {
								if (answer.requirements && answer.requirements.length > 0) {
									// use answer with every requirements fulfilled
									if (answer.requirements.every(requirement => conditions[requirement])) return answer.answer
								} else {
									// use default answer if no answer fulfilled every requirements yet
									if (!answerCandidate) return answer.answer
								}

								return answerCandidate
							}, null)

						return {
							question: content.question,
							answer
						}
					})
					.filter(content => content.answer) // filter content if no answer

				try {
					this.faq = this.faq.filter(content => {
						let question = content.question
						let answer = content.answer

						// normalize to string
						question = typeof question === 'string' ? question : JSON.stringify(question)
						answer = typeof answer === 'string' ? answer : JSON.stringify(answer)

						// concat string
						let entry = question + answer

						// custom filter
						if (!this.telco.sms.unsubscribe.keyword && entry.includes('{keyword}')) {
							return false
						}

						if (!this.telco.sms.unsubscribe.shortcode && entry.includes('{shortcode}')) {
							return false
						}

						if (!this.telco.subscription_package_description && entry.includes('{subscription_package_description}')) {
							return false
						}

						return true
					})

					let faqTemp = JSON.stringify(this.faq)

					faqTemp = faqTemp.replace(/{brand_name}/g, this.$i18n.t('brand_name'))
					faqTemp = faqTemp.replace(/{url_web}/g, `<a href='${this.urlWeb}' class='app-link'>${this.urlWeb.replace(/(^\w+:|^)\/\//, '')}</a>`)
					faqTemp = faqTemp.replace(/{subscription_package_description}/g, this.telco.subscription_package_description)
					faqTemp = faqTemp.replace(/{keyword}/g, this.telco.sms.unsubscribe.keyword)
					faqTemp = faqTemp.replace(/{shortcode}/g, this.telco.sms.unsubscribe.shortcode)

					this.faq = JSON.parse(faqTemp)
				} catch (err) {
					console.info('[FAQ] fail to replace text:')
					console.info(err)
				}

				this.isLoading = false
			},
			immediate: true
		}
	}
}
</script>

<style lang="scss" scoped>
section {
	background-color: $color-background;

	/deep/ .app-link {
		display: inline-block;
		color: $color-accent-turquoise !important;
		text-decoration: underline !important;
	}
}

.info-list {
	li {
		margin-left: $pd;
		padding-left: $pd / 2;
	}

	& > li {
		list-style-type: decimal;

		&:not(:last-child) {
			margin-bottom: $pd;
		}

		&.entry {
			font-weight: 700;

			.question {
				margin-bottom: $pd / 2;
			}

			.answer {
				font-weight: initial;

				& > ol {

					& > li {
						list-style-type: decimal;

						&:first-of-type { margin-top: $pd / 2 }
					}
				}
			}
		}
	}
}
</style>
